import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAppContext } from "../libs/contextLib";
import { onError } from "../libs/errorLib";
import { API } from "aws-amplify";

//import ForceGraph2D from "react-force-graph-2d";

import { Box } from "@mui/material";
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/AddCircleOutlineRounded';
//import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

//import Tabs from '@material-ui/core/Tabs';
//import Tab from '@material-ui/core/Tab';

import CustomStepper from "../components/CustomStepper";

import CustomTabs from "../components/CustomTabs";
import TabArtefactise from "../components/TabArtefactise";
//import TabExtract from "../components/TabExtract";
import TabNTABS from "../components/TabNTABS";
import TabDomains from "../components/TabDomains";
import TabGoals from "../components/TabGoals";
import TabParse from "../components/TabParse";
import TabMetadata from "../components/TabMetadata";

/*
function getSteps() {
    //return ['parse', 'artifactise', 'extraction', 'domains', 'goals'];
    //return ['parse', 'artifactise', 'extraction', 'domains', 'goals'];
    //return ['parse', 'artifactise', 'extraction', 'domains', 'goals'];
    return [
    {id:1,title:"parse", subtitle:"", completed: false},
    {id:2,title:"artifactise", subtitle:"", completed: false},
    {id:3,title:"extraction", subtitle:"", completed: false},
    {id:4,title:"domains", subtitle:"", completed: false},
    {id:5,title:"goals", subtitle:"", completed: false}];
}
    */





export default function PipelineViewer() {
    const history = useHistory();
    const location = useLocation();
    const { project } = location.state || {};
    const { isAuthenticated } = useAppContext();
    const [steps, setSteps] = useState([
        { id: 0, title: "parse", subtitle: "", state: "idle", completed: false, code: "PAR" },
        { id: 1, title: "artifactise", subtitle: "", state: "idle", completed: false, code: "ART" },
        { id: 2, title: "extraction", subtitle: "", state: "idle", completed: false, code: "TAB" },
        { id: 3, title: "domains", subtitle: "", state: "idle", completed: false, code: "DOM" },
        { id: 4, title: "goals", subtitle: "", state: "idle", completed: false, code: "GOL" }]);
    const [documents, setDocuments] = useState([]);
    //const [docId, setDocId] = useState(null);
    //const [fileUrl, setFileUrl] = useState(null);
    const [selectedDocument, setSelectedDocument] = useState(null);
    //const [resultsTitle, setResultsTitle] = useState('');
    //const [resultsData, setResultsData] = useState('');
    //const [isReadyToUpload, setIsReadyToUpload] = useState(false);
    const [fileDetails, setFileDetails] = useState(null);
    const [uploadStatus, setUploadStatus] = useState({ regenArtifacts: false, regenSdos: false, isFreeQuerying: false, isQuerying: false, isComplete: false, isUploading: false, isArtefacting: false, isParsing: false, isMetadating: false, isExtracting: false, parsingStatus: '', artefactingStatus: '', extractingStatus: '', resultsStatus: '', startTime: 0 });
    const uploadStatusRef = useRef(uploadStatus);
    const docRef = useRef(null);

    const [activeStep, setActiveStep] = React.useState(-1);
    //const steps = getSteps();

    const [tabStep, setTabStep] = useState(0);

    const [config, setConfig] = useState(null);

    const [models, setModels] = useState([]);


    const renderTabContent = () => {
        switch (tabStep) {
            case 0:
                return <TabParse project={project} docRef={docRef} config={config && config.parse} updateConfig={updateConfig} updateSteps={updateSteps} onDocUpdated={handleDocUpdated} disabled={uploadStatus.isUploading} />;
            /*case 2:
                return <TabMetadata project={project} docRef={docRef} config={config && config.meta} updateConfig={updateConfig} updateSteps={updateSteps} disabled={uploadStatus.isUploading} models={models} />;*/
            case 1:
                return <TabArtefactise project={project} docRef={docRef} config={config} updateConfig={updateConfig} updateSteps={updateSteps} onDocUpdated={handleDocUpdated} disabled={uploadStatus.isUploading} models={models} />;
            case 2:
                return <TabNTABS project={project} docRef={docRef} config={config} updateConfig={updateConfig} updateSteps={updateSteps} onDocUpdated={handleDocUpdated} disabled={uploadStatus.isUploading} models={models} />;
            case 3:
                return <TabDomains project={project} docRef={docRef} config={config} updateConfig={updateConfig} updateSteps={updateSteps} onDocUpdated={handleDocUpdated} disabled={uploadStatus.isUploading} models={models} />;
            case 4:
                return <TabGoals project={project} docRef={docRef} config={config} updateConfig={updateConfig} updateSteps={updateSteps} onDocUpdated={handleDocUpdated} disabled={uploadStatus.isUploading} models={models} />;
            default:
                return null;
        }
    };

    useEffect(() => {
        onLoad();
    }, []);


    async function onLoad() {
        if (!isAuthenticated) { history.push("/"); return; }
        if (project == undefined) { history.push("/"); return; }
        getDocs("", false);
        loadConfig();
        loadModels();
        console.log(project);
    }

    const loadConfig = async () => {
        const result = await getConfig();
        let cf = {};
        for (let i = 0; i < result.data.length; i++) {
            const val = result.data[i];
            const skArr = val.sk.split("|");
            const step = skArr[skArr.length - 1];
            cf[step.toLowerCase()] = val.content;
        }
        setConfig(cf);
    }

    const loadModels = async () => {

        const result = await getResults({ pk: "LOOKUP", sk: "MODL", mode: "get" });
        let modLookup = [];
        if (result.status && result.data) {
            modLookup = result.data.content.rows.map(row =>
                Object.fromEntries(result.data.content.columns.map((h, i) => [h.trim(), row[i].trim()]))
            );
        }
        setModels(modLookup);

    }

    function updateConfig(body) {
        setConfig(prev => ({
            ...prev,
            [body.type]: body.values,
        }));
        return API.patch("findigai", "/config", {
            body: body
        });
    }

    function getConfig() {
        return API.get("findigai", "/config");
    }
    function getResults(body) {
        return API.post("findigai", "/results/mode", {
            body: body
        });
    }
    function getDocuments() {
        return API.get("findigai", `/documents/${project.itemId}`);
    }

    function getDocument(id) {
        return API.get("findigai", `/documents/${project.itemId}/${id}`);
    }
    /*
    function getOpenAI(body) {
        return API.post("findigai", "/openai", {
            body: body
        });
    }
        */

    async function updateSteps(idx, completed, mustUpdateDoc = true, failed = false) {
        return;




        let id = 0;
        let updatedSteps;
        if (idx > -1) {
            id = steps[idx].id;

            updatedSteps = steps.map((step) =>
                step.id < id ? { ...step, completed: true, failed: false } : (step.id == id ? { ...step, completed, failed } : (step.id > id ? { ...step, completed: false, failed: false } : step))
            );

        } else {
            updatedSteps = steps.map((step) =>
                ({ ...step, completed: false, failed: false })
            );
        }
        setSteps(updatedSteps);
        setActiveStep(0);
        if (selectedDocument && mustUpdateDoc) {
            await getDocs(selectedDocument.itemId, false);
        }

    }



    const handleNextStep = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBackStep = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleResetSteps = () => {
        setActiveStep(-1);
    };

    const handleDocUpdated = async (doc = null) => {
        let updatedDoc = doc;
        if (!updatedDoc) {
            updatedDoc = await getDocument(docRef.current.itemId);
        }
        setDocuments(prev =>
            prev.map(d => (d.itemId === updatedDoc.itemId ? { ...d, ...updatedDoc } : d))
        );
        docRef.current = updatedDoc;
        setSelectedDocument(updatedDoc);
        console.log(updatedDoc);
        reconfigureSteps();
    };

    function reconfigureSteps() {
        const currentCode = docRef.current?.pipeline?.phase;
        const codeState = docRef.current?.pipeline?.state;
        let tempState = "idle";
        let currentActiveStep = -1;
        let updatedSteps = steps;
        for (let i = steps.length - 1; i >= 0; i--) {
            if (steps[i].code === currentCode) {
                steps[i].state = codeState;
                if (codeState !== "idle") {
                    currentActiveStep = i;
                } else {
                    currentActiveStep = i - 1;
                }
                tempState = "complete";
            } else {
                steps[i].state = tempState;
            }
        }
        setSteps(steps);
        setActiveStep(currentActiveStep);
    }



    const getDocs = async (id, setResults) => {
        const result = await getDocuments();
        const docs = result.data;
        console.log(docs);
        docs.sort((a, b) => {
            const nameCompare = a.name.localeCompare(b.name);
            if (nameCompare !== 0) {
                return nameCompare; // sort by name first
            }
            return a.version - b.version; // then by priority
        });
        setDocuments(docs);
        if (id && id != "") {
            const seldoc = result.data.filter(doc => doc.itemId == id);
            //console.log(id);




            setSelDoc(seldoc[0]);
            let resultsStr = seldoc[0].content;
            if (setResults) {
                try {
                    let cleanJsonString = resultsStr.replace(/```json|```/g, '').trim();
                    // eslint-disable-next-line no-control-regex
                    cleanJsonString = cleanJsonString.replace(/[\u0000-\u001F]+/g, "").replace(/\n/g, " ").trim();
                    cleanJsonString = cleanJsonString.replace(/"\s*,/g, '",').replace(/"\s*}/g, '"}');

                    const obj = JSON.parse(cleanJsonString);
                    resultsStr = JSON.stringify(obj, null, 2);
                } catch (e) {
                    console.log("JSON.parse failed: ", e.message);
                }
                //setResultsTitle("Document Metadata");
                //setResultsTitle(selectedDocument.name + " (" + selectedDocument.version + ") - Document Metadata");
                //setResultsData(resultsStr);
            }
        } else {
            setSelDoc(result.data[0]);
        }
        console.log(docs);
        setUploadStatus(prev => ({
            ...prev,
            isUploading: false,
            resultsStatus: ""
        }));
    }

    function setSelDoc(document) {
        //console.log(doc);
        if (document) {
            docRef.current = document;
            setSelectedDocument(document);
            reconfigureSteps();
            updateSteps(document.itemStatus - 1, true, false);
        }
    }

    const handleDocChange = async (event) => {
        event.preventDefault();
        //resetResults();
        //cancelAll(event);
        if (documents && documents.length > 0) {
            const seldoc = documents.filter(doc => doc.itemId == event.target.value);
            setSelDoc(seldoc[0]);
        }
        //console.log(seldoc);
    }

    const handleUploadClick = async (event) => {
        event.preventDefault();
        console.log(uploadStatus);
        if (uploadStatus.isUploading) {
            return;
        }
        //console.log(event.target.files.length);
        if (event.target.files.length == 0) {
            return;
        }

        const file = event.target.files[0];
        //const result = await getDocuments();
        let isDuplicate = false;
        let version = 0;
        for (const doc of documents) {
            if (doc.name == file.name) {
                isDuplicate = true;
                if (doc.version && doc.version > version) {
                    version = doc.version;
                }
            }
        }
        version++;
        const details = { file: file, version: version, isDuplicate: isDuplicate };
        setFileDetails(details);
        const newDoc = { itemId: "NEW", name: file.name, version: version };
        setDocuments(prevItems => [...prevItems, newDoc]);
        setSelDoc(newDoc);
        if (!isDuplicate) {
            //setIsReadyToUpload(true);
            uploadDocument(details);
        }
    }

    const openFileDialog = () => {
        const input = document.getElementById("upload-data");
        input.value = ""; // Reset the input to allow re-selection of the same file
    };

    const continueFileUpload = (event) => {
        event.preventDefault();
        //setIsReadyToUpload(true);
        uploadDocument(fileDetails);
    };

    const uploadDocument = async (fd) => {
        //resetResults();
        //saveConfig();
        setUploadStatus(prev => ({
            ...prev,
            isUploading: true,
            resultsStatus: "uploading",
            startTime: Date.now()
        }));


        //fileIndex = -1;
        const file = fd.file;
        const version = fd.version;
        setFileDetails(null);
        //console.log(file);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = async () => {
            const base64String = reader.result.split(',')[1]; // Get base64 data
            try {
                uploadDoc({ type: "upload", projectId: project.itemId, doc: base64String, fileName: file.name, version: version })
                    .then(resultParse => {
                        //console.log("Got data:", resultParse);
                        //const data = typeof resultParse.data === "string" ? JSON.parse(resultParse.data) : resultParse.data;
                        //setDocId(resultParse.docId);
                        //const { id, status} = data;
                        //setParsingStatus(status);
                        //setJobId(id);
                        //setIsParsing(true);
                        /*
                        setUploadStatus(prev => ({
                        ...prev,
                        isParsing: true,
                        resultsStatus: uploadStatusRef.current.resultsStatus+"parsing"
                        }));
                        */

                        //setFileUrl(resultParse.location);

                        getDocs(resultParse.docId, false);
                    })
                    .catch(err => {
                        console.error('Error uploading file:', err);
                    });
            } catch (error) {
                console.error('Error uploading file:', error);
            }
        };
    }

    function uploadDoc(body) {
        return API.post("findigai", "/parse", {
            body: body
        });
    }

    function handleTabChange(event, value) {
        event.preventDefault();
        //console.log(value, steps[value].id);
        setTabStep(value);
    };


    function renderLander() {
        return (
            <Box p={0} sx={{ backgroundColor: "#f5f5f5" }}>
                <Box pb={1} display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' sx={{ color: "#383" }}>
                    <Typography variant="h5" >Project: </Typography>&nbsp;
                    <Typography variant="h5" fontWeight="bold"> <b>{project ? project.name : ""}</b></Typography>
                </Box>
                <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' sx={{
                    backgroundColor: '#acf',
                    px: 2,
                    color: 'white',
                }}>
                    <Typography variant="h6" >Document: </Typography>&nbsp;
                    {documents.length > 0 &&
                        <Box my={0} ml={0.5}>
                            <Select
                                fullWidth
                                id="documentsList"
                                name="documentsList"
                                label="documentsList"
                                value={selectedDocument && selectedDocument.itemId}
                                onChange={handleDocChange}
                            >
                                {documents.map((doc) => (
                                    <MenuItem value={doc.itemId}>  <Typography variant="h6" sx={{ color: "#fff" }}><b>{doc.name}</b>{doc.version ? " (v." + doc.version + ")" : ""}</Typography></MenuItem>
                                ))}

                            </Select>
                        </Box>
                    }

                    <Box sx={{ flexGrow: 1, textAlign: "right", alignContent: "center", alignItems: "center" }} >
                        <Box my={2} ml={0.5}>
                            <label htmlFor="upload-data">
                                <input
                                    accept=".PDF"

                                    id="upload-data"
                                    name="upload-data"
                                    multiple="false"
                                    type="file"
                                    onChange={handleUploadClick}
                                    hidden
                                />
                                <Tooltip title="Add document">
                                    <AddIcon ml={2}
                                        disabled={uploadStatus.isUploading}
                                        onClick={openFileDialog}
                                        color="#fff"
                                        style={{ fontSize: 30 }}
                                    />
                                </Tooltip>
                                {documents.length == 0 &&
                                    <>
                                        &nbsp;Add First Document
                                    </>
                                }
                            </label>
                        </Box>
                    </Box>
                </Box>
                <CustomStepper steps={steps} activeStep={activeStep} />
                <Box px={1} sx={{
                    width: '100%',
                    bgcolor: '#ffffff00',
                    color: 'white',
                }}>
                    <CustomTabs
                        disabled={documents.length == 0 || !selectedDocument || uploadStatus.isUploading}
                        tabs={steps}
                        value={tabStep}
                        onChange={handleTabChange}
                    />
                    <Box p={2} sx={{
                        width: '100%',
                        bgcolor: 'white',
                        color: '#333',
                    }}>
                        {config && renderTabContent()}
                    </Box>
                    <Box p={2} sx={{
                        width: '100%',
                        bgcolor: 'white',
                        color: 'white',
                    }}>
                        {/*sites && sites.length > 1 && tabSite >= 0 && renderProjectLists()*/}
                    </Box>
                </Box>

            </Box>

        )
    }



    return (
        <>
            {renderLander()}
            <Dialog
                open={fileDetails && fileDetails.isDuplicate}
                fullWidth={false}
                maxWidth={'md'}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title" style={{ color: "#10385A" }} >
                    Document Upload
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        A file with the same name (<b>{fileDetails && fileDetails.file.name}</b>) has already been uploaded. Click CONTINUE to continue with the upload creating a new version (<b>v.{fileDetails && fileDetails.version}</b>) of the document.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={(e) => {
                        setFileDetails(null);
                        setDocuments(prevDocs => prevDocs.filter(doc => doc.itemId !== "NEW"));
                        setSelDoc(documents[0]);
                    }} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={continueFileUpload} color="secondary">
                        CONTINUE
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}